export default "__VITE_ASSET__Dd1gXnvp__"